import React from "react";
import { Button } from "../../../components/tailwind";

type ChatDeleteDialogProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  confirmAction: () => void;
  header: React.ReactElement;
};

export const ChatDeleteDialog: React.FC<ChatDeleteDialogProps> = ({
  open,
  setOpen,
  confirmAction,
  header,
}) => {
  return (
    <div className={`tw-w-full ${open ? " " : "tw-hidden"}`}>
      <header>{header}</header>
      <div className="tw-flex tw-gap-1 tw-mt-2">
        <Button
          className="tw-grow"
          data-testid="section-modal-close-confirm"
          content="Cancel"
          size="sm"
          variant="secondary"
          onClick={(): void => setOpen(false)}
        />
        <Button
          className="tw-grow"
          data-testid="section-modal-confirm-action"
          content="Confirm"
          size="sm"
          variant="primary"
          onClick={(): void => {
            confirmAction();
            setOpen(false);
          }}
        />
      </div>
    </div>
  );
};
